import config from "./config"

/**
 * 生成指定长度随机数
 * @param length
 * @returns {string}
 */
export function makeRandom (length) {
  let str = "0123456789", ret = "";
  for (let i = 0; i < length; i++) {
    ret += str.substr(Math.floor(Math.random() * str.length), 1);
  }
  return ret;
}

/**
 * 根据条件返回数组指定元素
 * @param array
 * @param fn
 * @returns {null}
 */
export function arrayFind (array, fn) {
  let index = array.findIndex(fn);
  return index > -1 ? array[index] : null;
}

/**
 * 获得咨询状态
 * @param status
 * @returns {string}
 */
export function getConsultStatusText (status) {
  let c = arrayFind(config.consult_status, (res) => {
    return res.status == status
  });
  return c ? c.name : "暂无";
}

/**
 * 获得订单状态
 * @param status
 */
export function getBookOrderStatusText (status) {
  return arrayFind(config.book_order_status, (res) => {
    return res.status == status
  }).name
}

/**
 * 判断浏览器类型
 * @param name
 * iphone
 * android
 * micromessenger
 * @returns {boolean}
 */
export function isBrower (name) {
  let UA = window.navigator.userAgent.toLowerCase();
  return UA.indexOf(name) > -1;
}

/**
 * 密码加密处理
 * @param pass
 * @returns {*}
 */
export function passFormat (pass) {
  return sha512(hex_md5(pass) + pass);
}


/**
 * @param args
 */
export function debug (...args) {
  console.log.apply(console, args);
}


/**
 * 生成返回URL
 * @param options
 * @returns {string}
 */
export function makeUrl (options) {
  let url = "";
  if (options.protocol) {
    url += options.protocol + "://"
  }
  if (options.hostname) {
    url += options.hostname
  }
  if (options.port && options.port != 80 && options.port != 443) {
    url += ":" + options.port
  }
  if (options.path) {
    url += options.path
  }
  if (options.query) {
    let q = "";
    for (let key in options.query) {
      if (options.query[key]) {
        q += `&${key}=${options.query[key]}`
      } else {
        q += `&${key}`
      }

    }
    q = q.substr(1);
    url += "?" + q
  }
  if (options.hash) {
    url += "#" + options.hash;
  }
  return url;
}

/**
 * 解析url参数
 * @param from
 * @returns {{protocol: *, hostname: *, port: *, path: *, query: *, hash: *}}
 */
export function getParamsFromUrl (from) {
  let protocol = url("protocol", from);
  let hostname = url("hostname", from);
  let port = url("port", from);
  let path = url("path", from);
  let query = url("?", from);
  let hash = url("hash", from);
  return { protocol, hostname, port, path, query, hash }
}



// WEBPACK FOOTER //
// ./src/lib/util.js